"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.image = exports.text = exports.index = exports.wrapper = void 0;

const wrapper = () => ({
  overflow: 'hidden',
  position: 'relative'
});

exports.wrapper = wrapper;

const index = () => ({
  zIndex: 1
});

exports.index = index;

const text = () => ({
  wordBreak: 'break-word'
});

exports.text = text;

const image = () => ({
  bottom: '0',
  position: 'absolute',
  right: '-2%',
  width: '70%'
});

exports.image = image;
//# sourceMappingURL=HeroCard.style.js.map